
import Galleria from "primevue/galleria";
import { defineComponent } from "vue";
export default defineComponent({
  components: {
    Galleria,
  },
  props: {
    data: {
      type: Object,
      //default: () => {},
    },
    display: {
      type: Array,
      default: () => ["image", "title", "description", "infoList", "location"],
    },
    display_left: {
      type: Array,
      default: () => ["title", "description", "accordion", "linkList"],
    },
    compact: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    image: null,
    productURL: "/",
    showGallery: false,
  }),
  mounted() {
    this.image = require("@/assets/images/slide-2.jpg");
    if (this.data?.gallery) {
      this.data.gallery.map((item: any) => {
        item.itemImageSrc = require("@/assets/images/" + item.itemImageSrc);
        item.thumbnailImageSrc = require("@/assets/images/" +
          item.thumbnailImageSrc);
      });
    }
    this.productURL = "/product/" + this.data?.id;
  },
  methods: {
    displayContains(el: any) {
      return this.display.indexOf(el) > -1;
    },
    displayLeftContains(el: any) {
      return this.display_left.indexOf(el) > -1;
    },
  },
});
